<template>
  <header class="home-header">
    <section class="home-header__content">
      <div v-appear:left="{ delay: [$scroll, 750], threshold: 0 }" class="home-header__figure">
        <video autoplay muted loop src="https://forum.medioze.com/video/FEIA-intro.mp4" class="home-header__video" />
      </div>

      <h1 class="home-header__banner">
        <span v-appear:down="{ delay: [$scroll, 825, 125] }">{{ $t('home.header.message') }}</span>
        <br />
        <span v-appear="{ delay: [$scroll, 900, 200] }" class="home-header__cursive">{{ $t('home.header.span') }}</span>
      </h1>
    </section>
  </header>
</template>

<script>
export default {
  name: 'HomeHeader'
}
</script>
